import React, { useEffect } from 'react';
import './About.css';

const About: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const heroImage = "https://images.unsplash.com/photo-1562663474-6cbb3eaa4d14?q=80&w=2070&auto=format&fit=crop"; // Painter tools or clean wall
  
  const workImages = [
    { src: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=800&q=80", alt: "Festés folyamatban" },
    { src: "https://images.unsplash.com/photo-1574359411659-15573a27fd0c?w=800&q=80", alt: "Előkészületek" },
    { src: "https://images.unsplash.com/photo-1595846519845-68e298c2edd8?w=800&q=80", alt: "Részletek" }
  ];

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="hero-overlay"></div>
        <div className="hero-content fade-in-up">
          <h1 className="hero-title">Szenvedélyem a Festés</h1>
          <p className="hero-subtitle">Precizitás • Minőség • Megbízhatóság</p>
        </div>
      </section>

      <div className="container">
        {/* Intro Section */}
        <section className="section about-intro">
          <div className="content-grid">
            <div className="about-image-wrapper fade-in-left">
              <img 
                src="https://lakicsfesto.com/img/lakicsperson.webp" 
                alt="Lakics Márk" 
                className="profile-image shadow-lg"
              />
            </div>
            <div className="text-content fade-in-right">
              <h2 className="section-title">Lakics Márk</h2>
              <h3 className="section-subtitle-text">Szobafestő Mester</h3>
              <p className="section-desc">
                Üdvözlöm! Több mint 10 éve foglalkozom szobafestéssel és belső terek felújításával. 
                Számomra ez nem csak munka, hanem alkotás. Célom, hogy ügyfeleim elképzeléseit 
                tökéletesen megvalósítsam, legyen szó egy egyszerű tisztasági festésről vagy 
                komplex dekorációs megoldásokról.
              </p>
              <p className="section-desc">
                Bönyön élek, de Győr és környékén rendszeresen vállalok megbízásokat. 
                Hiszek a folyamatos fejlődésben, ezért rendszeresen képzem magam az új 
                technológiák és anyagok terén.
              </p>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="section values-section">
          <h2 className="section-title center">Értékeim</h2>
          <div className="values-grid-clean">
            <div className="value-card">
              <span className="value-icon">✨</span>
              <h3>Minőség</h3>
              <p>Nem ismerek kompromisszumot a felhasznált anyagok és a kivitelezés terén.</p>
            </div>
            <div className="value-card">
              <span className="value-icon">🤝</span>
              <h3>Megbízhatóság</h3>
              <p>A megbeszélt határidőket és árakat mindig betartom.</p>
            </div>
            <div className="value-card">
              <span className="value-icon">🧹</span>
              <h3>Tisztaság</h3>
              <p>Munkám során és végeztével is ügyelek a rendre és tisztaságra.</p>
            </div>
          </div>
        </section>

        {/* Experience Timeline - Minimalist */}
        <section className="section timeline-section">
          <h2 className="section-title center">Szakmai Út</h2>
          <div className="minimal-timeline">
            <div className="timeline-block">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <span className="year">2014 - Jelenleg</span>
                <h3>Egyéni Vállalkozó</h3>
                <p>Önálló projektek, teljes körű lakásfelújítások, ügyfélkör kiépítése.</p>
              </div>
            </div>
            <div className="timeline-block">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <span className="year">2010 - 2014</span>
                <h3>Szakmai Tapasztalat</h3>
                <p>Kiemelt festő cégeknél szerzett gyakorlat, speciális technikák elsajátítása.</p>
              </div>
            </div>
            <div className="timeline-block">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <span className="year">2008 - 2010</span>
                <h3>Tanulmányok</h3>
                <p>Szobafestő szakma alapjainak elsajátítása kiváló eredménnyel.</p>
              </div>
            </div>
          </div>
        </section>

       
       
      </div>
    </div>
  );
};

export default About;
